import styled from 'styled-components';
import { HeaderRow, OptionRow, OptionsGrid } from '../../../../components/layout/rows/styled';
import {
    OptionCard,
    OptionContent,
    OptionDescription,
    OptionNote,
    OptionTitle
} from '../../../../components/OptionCard/styled';

export { HeaderRow, OptionRow, OptionsGrid };
export { OptionCard, OptionContent, OptionDescription, OptionNote, OptionTitle };

export const Container = styled.div`
    width: 100%;
`;
